import { Helper } from "../../core/util/helper.js";
import { Skill, SkillCategory, SkillCategoryVm, TreeNodeVm } from "./skillsInterfaces.js";

export class SkillHelper {

    public static getAllSkillCategories(data: TreeNodeVm[]): SkillCategory[] {
        let allSkillsCategories: SkillCategory[] = [];
        for (let root of data) {
            let skills = this.getSkillCategoriesRecursive(root);
            allSkillsCategories.push(...skills);
        }
        return allSkillsCategories;
    }

    private static getSkillCategoriesRecursive(treeNode: TreeNodeVm) {
        let allSkillCategories: SkillCategory[] = [];
        let skills: Skill[] = treeNode.Children.filter(x => x.IsSkill).map(y => y.Item);
        let item: SkillCategoryVm = treeNode.Item;

        let skillCategoy: SkillCategory = {
            Fid: item.Id,
            Ftext: item.FText,
            Skills: skills
        }
        allSkillCategories.push(skillCategoy);

        let subNodes = treeNode.Children.filter(x => !x.IsSkill);
        for (let subNode of subNodes) {
            let subNodeSkills = this.getSkillCategoriesRecursive(subNode);
            allSkillCategories.push(...subNodeSkills);
        }
        return allSkillCategories;
    }

    public static getFilledSkills = (data: TreeNodeVm[]) => {
        let lst = [];
        if (Helper.hasValue(data)) {
            let skills = this.getAllSkills(data);
            lst = skills.filter(x => x.Wert > 0);
            //for (let filledSkill of filledSkills) {
            //    //let arr = [filledSkill.Rtext, filledSkill.Wert];
            //    lst.push(filledSkill);
            //};
        }
        return lst;
    }

    private static getAllSkills(data: TreeNodeVm[]) {
        let allSkills: Skill[] = [];
        for (let root of data) {
            let skills = this.getSkillsFromCategoryRecursiv(root);
            allSkills.push(...skills);
        }
        return allSkills;
    }

    private static getSkillsFromCategoryRecursiv(treeNode: TreeNodeVm) {
        let allSkills: Skill[] = [];
        let skills = treeNode.Children.filter(x => x.IsSkill);
        for (let skill of skills) {
            allSkills.push(skill.Item);
        }
        let subNodes = treeNode.Children.filter(x => !x.IsSkill);
        for (let subNode of subNodes) {
            let subNodeSkills = this.getSkillsFromCategoryRecursiv(subNode);
            allSkills.push(...subNodeSkills);
        }
        return allSkills;
    }

    public static getRefPos(type: "resource" | "address" | "machine" | "machinetype" | "ticket" | "assignment" | "project", index: number = 0) {
        let pos = 0;
        switch (type) {
            case ("resource"):
                pos = 1;
                break;
            case ("address"):
                pos = 6;
                break;
            case ("machine"):
                pos = 4;
                break;
            case ("machinetype"):
                pos = 5;
                break;
            case ("ticket"):
                pos = 10;
                break;
            case ("project"):
                pos = 13;
                break;
            case ("assignment"):
                pos = index + 1000;
                break;
        }
        return pos;
    }
}